<template>
  <div>
    <div class="tabs hide-small">
      <div :class="[ tab === 'main' ? 'active' : '' ]" @click="tab = 'main'">Main details</div>
      <div :class="[ tab === 'archive' ? 'active' : '' ]" @click="reoptimise(entity)">Re-Quote</div>
    </div>
    <section id="main-content cont" class="clearfix">
      <div class="clearfix" slot="admin-content" id="location-content">
        <div class="content">
          <div class="form-steps-outer">
            <loader v-if="loading"/>
            <div class="backer clearfix inverse row" v-else>
              <div class="entity-values clearfix">
                <hr class="hr-text" data-content="Primary"/>
                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <div class="tag">
                    <div class="key-head">Job Name</div>
                    <div class="val">{{ jobName(entity) || 'None set' }}</div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <div class="tag">
                    <div class="key-head">Inquiry Ref</div>
                    <div class="val">{{ entity.job && entity.job.inquiryRef }} - {{ entity.job && entity.job.variation }}</div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <div class="tag">
                    <div class="key-head">Origin</div>
                    <div class="val">{{ origin(entity) || 'None set' }}</div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <div class="tag">
                    <div class="key-head">Destination</div>
                    <div class="val">{{ destination(entity) || 'None set' }}</div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <div class="tag">
                    <div class="key-head">Job Type</div>
                    <div class="val">{{ jobType(entity) || 'None set' }}</div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <div class="tag">
                    <div class="key-head">Weight (Net LBS)</div>
                    <div class="val">{{ netLbs(entity) || 'None set' }}</div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <div class="tag">
                    <div class="key-head">Weight (Net KG)</div>
                    <div class="val">{{ netKgs(entity) || 'None set' }}</div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <div class="tag">
                    <div class="key-head">Volume (Net CbFt)</div>
                    <div class="val">{{ netCbFt(entity) || 'None set' }}</div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <div class="tag">
                    <div class="key-head">Volume (Net CBM)</div>
                    <div class="val">{{ volNetM3(entity) || 'None set' }}</div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <div class="tag">
                    <div class="key-head">Route Cost</div>
                    <div class="val">
                      <strong>{{ numberFormat(totalCost(entity)) }} {{ quoteCurrency(entity) }}</strong>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <div class="tag">
                    <div class="key-head">Route Charges</div>
                    <div class="val">
                      <strong>{{ numberFormat(totalCharge(entity)) }} {{ quoteCurrency(entity) }}</strong>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <div class="tag">
                    <div class="key-head">Profit</div>
                    <div class="val">
                      <strong>{{ symbol(entity) }} {{ numberFormat(profitLoss(entity)) }} {{ quoteCurrency(entity) }}</strong>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="hasComparison" class="entity-comparison clearfix">
                <hr class="hr-text" data-content="Comparison"/>
                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <div class="tag">
                    <div class="key-head">Origin</div>
                    <div class="val">{{ origin(comparison) || 'None set' }}</div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <div class="tag">
                    <div class="key-head">Destination</div>
                    <div class="val">{{ destination(comparison) || 'None set' }}</div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <div class="tag">
                    <div class="key-head">Job Name</div>
                    <div class="val">{{ jobName(comparison) || 'None set' }}</div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <div class="tag">
                    <div class="key-head">Job Type</div>
                    <div class="val">{{ jobType(comparison) || 'None set' }}</div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <div class="tag">
                    <div class="key-head">Weight (Net LBS)</div>
                    <div class="val">{{ netLbs(comparison) || 'None set' }}</div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <div class="tag">
                    <div class="key-head">Weight (Net KG)</div>
                    <div class="val">{{ netKgs(comparison) || 'None set' }}</div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <div class="tag">
                    <div class="key-head">Volume (Net CbFt)</div>
                    <div class="val">{{ netCbFt(comparison) || 'None set' }}</div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <div class="tag">
                    <div class="key-head">Volume (Net CBM)</div>
                    <div class="val">{{ volNetM3(comparison) || 'None set' }}</div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <div class="tag">
                    <div class="key-head">Route Cost</div>
                    <div class="val">
                      <strong>{{ numberFormat(totalCost(comparison)) }} {{ quoteCurrency(comparison) }}</strong>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <div class="tag">
                    <div class="key-head">Route Charges</div>
                    <div class="val">
                      <strong>{{ numberFormat(totalCharge(comparison)) }} {{ quoteCurrency(comparison) }}</strong>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <div class="tag">
                    <div class="key-head">Profit</div>
                    <div class="val">
                      <strong>{{ symbol(comparison) }} {{ numberFormat(profitLoss(comparison)) }} {{ quoteCurrency(comparison) }}</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="clearfix" v-if="!loading">
          <job-archive
            v-if="entity.job.masterJob"
            :master-job="entity.job.masterJob"
            :primary-id="entity && entity.job && entity.job.id"
            @compare="compare"
            @star="makePrimary"
            @updateStatus="updateJobStatus"
          />
          <vuetable
            :showEdit="false"
            :showDelete="false"
            :tableData="costs(entity)"
            :tableTitle="'Costs'"
            :fields="fields"
            :maxItems="costs(entity).length"
          />
          <vuetable
            v-if="hasComparison"
            class="comparison"
            :showEdit="false"
            :showDelete="false"
            :tableData="costs(comparison)"
            :tableTitle="'Comparison Costs'"
            :fields="fields"
            :maxItems="costs(comparison).length"
          />
          <vuetable
            :showEdit="false"
            :showDelete="false"
            :tableData="charges(entity)"
            :tableTitle="'Charges'"
            :fields="chargeFields"
            :maxItems="charges(entity).length"
          />
          <vuetable
            v-if="hasComparison"
            class="comparison"
            :showEdit="false"
            :showDelete="false"
            :tableData="charges(comparison)"
            :tableTitle="'Comparison Charges'"
            :fields="chargeFields"
            :maxItems="charges(comparison).length"
          />
          <div class="panel panel-default" v-if="isSystemOptionParameterEnabled('ENABLE_ACCESSORIALS')">
            <div class="panel-heading">
              <h4>Accessorials</h4>
            </div>
            <div class="panel-body">
              <div class="col-xs-12">
                <vuetable
                  :showEdit="false"
                  :showDelete="false"
                  :tableData="originAccessorials(entity)"
                  tableTitle="Origin Accessorials"
                  :fields="accessorialFields"
                  :maxItems="originAccessorials(entity).length"
                />
                <vuetable
                  v-if="hasComparison"
                  class="comparison"
                  :showEdit="false"
                  :showDelete="false"
                  :tableData="originAccessorials(comparison)"
                  tableTitle="Comparison Origin Accessorials"
                  :fields="accessorialFields"
                  :maxItems="originAccessorials(comparison).length"
                />
              </div>
              <div class="col-xs-12">
                <vuetable
                  :showEdit="false"
                  :showDelete="false"
                  :tableData="destinationAccessorials(entity)"
                  tableTitle="Destination Accessorials"
                  :fields="accessorialFields"
                  :maxItems="destinationAccessorials(entity).length"
                />
                <vuetable
                  v-if="hasComparison"
                  class="comparison"
                  :showEdit="false"
                  :showDelete="false"
                  :tableData="destinationAccessorials(comparison)"
                  tableTitle="Comparison Destination Accessorials"
                  :fields="accessorialFields"
                  :maxItems="destinationAccessorials(comparison).length"
                />
              </div>
            </div>
          </div>
          <div class="panel panel-default" v-if="isSystemOptionParameterEnabled('ENABLE_QUOTE_TAXES')">
            <div class="panel-heading">
              <h4>GST-VAT</h4>
            </div>
            <div class="panel-body">
              <div class="col-md-1 col-lg-7">
                <vuetable
                  :showEdit="false"
                  :showDelete="false"
                  :tableData="taxes(entity)"
                  tableTitle="GST-VAT"
                  :fields="taxFields"
                  :maxItems="taxes(entity).length"
                />
                <vuetable
                  v-if="hasComparison"
                  class="comparison"
                  :showEdit="false"
                  :showDelete="false"
                  :tableData="taxes(comparison)"
                  tableTitle="Comparison GST-VAT"
                  :fields="taxFields"
                  :maxItems="taxes(comparison).length"
                />
              </div>
            </div>
          </div>
          <div v-if="jobPrintReport && jobPrintReport.valueAlpha" class="pull-right">
            <button class="btn btn-info sq btn-print btn-external-link" type="button" @click="print">
              Print
            </button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import AdminEntityMixin from '../../mixins/AdminEntityMixin'
  import HelperMixin from '../../mixins/Helpers'
  import api from '../../../../api/endpoints'
  import Loader from '../../../helpers/Loader.vue'
  import vuetable from '../../../helpers/VueTable.vue'
  import JobArchive from './JobArchive'
  import ReportMixin from '../../../../mixins/ReportMixin'
  import { createRouteIdHash } from '../../../helpers/RouteHash'
  import event from '../../../../event'
  export default {
    name: 'Job',
    mixins: [AdminEntityMixin, HelperMixin, ReportMixin],
    props: {
      id: {
        type: String
      }
    },
    components: { Loader, vuetable, JobArchive },
    data () {
      return {
        validityCriteria: [],
        transformForUpdate: {},
        newEntityScreen: 'Admin - Jobs',
        editEntityScreen: 'Admin - Edit/View Job',
        tab: 'main',
        boxes: [],
        entity: {
          services: [],
          finances: [],
          accessorials: [],
          job: {
            quoteCurrency: { code: null },
            jobType: { name: null },
            jobName: null,
            masterJob: null,
            status: null
          },
          volumes: []
        },
        comparison: {
          services: [],
          finances: [],
          job: {
            quoteCurrency: { code: null },
            jobType: { name: null },
            jobName: null,
            masterJob: null,
            id: null
          },
          volumes: []
        },
        entityName: 'job',
        loading: true,
        fields: [
          { header: 'Description', prop: item => item.jobService && item.jobService.description },
          { header: 'From', prop: item => item.jobService && item.jobService.fromLocation && item.jobService.fromLocation.name },
          { header: 'To', prop: item => item.jobService && item.jobService.toLocation && item.jobService.toLocation.name },
          { header: 'Provider', prop: item => item.jobService && item.jobService.serviceProvider && item.jobService.serviceProvider.name },
          { header: 'Rate', prop: this.getAmount, numericalField: true, tooltip: item => item.jobService && item.jobService.note }
        ],
        chargeFields: [
          { header: 'Name', prop: item => item.financeProfileItem ? item.financeProfileItem.name : 'Rate Adjustment' },
          { header: 'Rate', prop: this.getChargeAmount, numericalField: true }
        ],
        accessorialFields: [
          { header: 'Description', prop: this.getAccessorialDescription },
          { header: 'Per', prop: item => item && item.accessorial.ratesPerName },
          { header: 'Accessorial Rate', prop: this.getAccessorialAmount },
          { header: 'Accessorial Base Rate', prop: this.getAccessorialBaseAmount },
          { header: 'Quantity', prop: item => item && item.quantity },
          { header: 'Currency Subtotal', prop: this.getAccessorialSubtotal, numericalField: true },
          { header: 'Base Subtotal', prop: this.getAccessorialBaseSubtotal, numericalField: true }
        ],
        taxFields: [
          { header: 'Service', prop: this.getQuoteTaxDescription },
          { header: '', prop: item => item && item.quoteTax ? `${item.quoteTax.rate}%` : '' }
        ]
      }
    },
    computed: {
      isValid () {
        let valid = true
        this.validityCriteria.forEach(prop => {
          valid = this.entity[prop] === '' || this.entity[prop] === null ? false : valid
        })
        return valid
      },
      hasComparison () {
        return this.comparison && this.comparison.job && this.comparison.job.id
      },
      jobPrintReport () {
        return this.$store.getters['systemOption/defaultOption']('JOB_PRINT_REPORT')
      }
    },
    methods: {
      reoptimise (entity) {
        const query = { autofillFromParams: 1 }
        if (entity.job) {
          if (entity.job.masterJob) {
            query.masterJob = entity.job.masterJob
          }
          query.job = createRouteIdHash(entity.job.id)
          if (entity.job.containerType) {
            query.containerType = entity.job.containerType
          }
          if (entity.job.jobType) {
            query.jobType = entity.job.jobType.id
          }
          if (entity.job.fromLocation) {
            query.fromN = entity.job.fromLocation.name
            query.fromS = entity.job.fromLocation.subdivision
            if (entity.job.fromLocation.country) {
              query.fromC = entity.job.fromLocation.country.code
            }
          }
          if (entity.job.toLocation) {
            query.toN = entity.job.toLocation.name
            query.toS = entity.job.toLocation.subdivision
            if (entity.job.toLocation.country) {
              query.toC = entity.job.toLocation.country.code
            }
          }
        }
        if (this.hasVolume(entity)) {
          const copyVolFields = [
            'acwGrsKgs',
            'density',
            'netToGross',
            'volGrsCuf',
            'volGrsM3',
            'volNetCuf',
            'volNetM3',
            'wgtGrsKgs',
            'wgtGrsLbs',
            'wgtNetKgs',
            'wgtNetLbs'
          ]
          const vol = entity.volumes[0]
          copyVolFields.forEach(prop => {
            if (vol[prop]) {
              query[prop] = vol[prop]
            }
          })
        }
        this.$router.push({ name: 'Add a new Quote', query })
      },
      print () {
        if (this.entity && this.entity.job && this.jobPrintReport) {
          const reportParams = {
            filename: this.jobPrintReport.valueAlpha,
            init: this.jobPrintReport.externalCode,
            inquiryRef: this.entity.job.inquiryRef,
            variation: this.entity.job.variation
          }
          this.generateReport(reportParams)
        }
      },
      makePrimary ({ id }) {
        this.$http.put(`${api.JOB}/primary/${id}`)
          .then(() => this.$router.push({ name: 'Admin - Edit/View Job', params: { id: createRouteIdHash(id) } }))
          .catch(console.error)
      },
      updateJobStatus (tableJob, newJobStatus, cancelReason) {
        const job = {
          id: tableJob.id,
          jobStatusCode: newJobStatus,
          cancelReason: cancelReason
        }
        this.$http.put(`${api.JOB}/${job.id}`, job)
            .then(() => {
              event.$emit('toast', { type: 'success', message: `Status update successful` })
              if (newJobStatus === 'PRIMARY') {
                this.$router.push({ name: this.editEntityScreen, params: {id: createRouteIdHash(job.id)} })
              } else {
                this.init()
              }
            })
            .catch(console.error)
      },
      // UI methods
      totalCost (entity) {
        return parseFloat(entity.finances.filter(({category}) => category === 'COST').reduce((acc, current) => Number(acc) + Number(current.amount), 0)).toFixed(2)
      },
      totalCharge (entity) {
        return parseFloat(entity.finances.filter(({category}) => category === 'CHARGE').reduce((acc, current) => Number(acc) + Number(current.amount), 0)).toFixed(2)
      },
      quoteCurrency (entity) {
        return entity.job && entity.job.quoteCurrency && entity.job.quoteCurrency.code
      },
      jobName (entity) {
        return entity.job && entity.job.jobName && entity.job.jobName.trim()
      },
      origin (entity) {
        return entity.job && entity.job.fromLocation && this.displayLocation(entity.job.fromLocation)
      },
      destination (entity) {
        return entity.job && entity.job.toLocation && this.displayLocation(entity.job.toLocation)
      },
      jobType (entity) {
        return entity.job && entity.job.jobType && entity.job.jobType.name
      },
      costs (entity) {
        const costs = entity.finances.filter(({category}) => category === 'COST').sort(this.orderBySequence)
        const total = {
          jobService: { description: '', fromLocation: { name: '' }, toLocation: { name: '' }, serviceProvider: { name: '' } },
          exchangeRate: 1,
          amount: this.totalCost(entity)
        }
        return [...costs, total]
      },
      charges (entity) {
        const charges = entity.finances.filter(({category}) => category === 'CHARGE')
        const total = {
          source: '',
          totalType: '',
          currency: entity.job.quoteCurrency,
          amount: charges.reduce((acc, current) => Number(acc) + Number(current.amount), 0),
          financeProfileItem: { name: 'Total' }
        }
        return [...charges, total]
      },
      accessorials (entity) {
        return entity.accessorials || []
      },
      originAccessorials (entity) {
        return this.accessorials(entity).filter(item => item.accessorial && item.accessorial.serviceClass && (item.accessorial.serviceClass.code === 'OZ' || item.accessorial.serviceClass.code === 'OA'))
      },
      destinationAccessorials (entity) {
        return this.accessorials(entity).filter(item => item.accessorial && item.accessorial.serviceClass && (item.accessorial.serviceClass.code === 'DZ' || item.accessorial.serviceClass.code === 'DA'))
      },
      taxes (entity) {
        return entity.taxes || []
      },
      hasVolume (entity) {
        return entity.volumes && Array.isArray(entity.volumes) && entity.volumes.length > 0
      },
      netLbs (entity) {
        return this.hasVolume(entity) && entity.volumes[0].wgtNetLbs && this.numberFormat(entity.volumes[0].wgtNetLbs)
      },
      netKgs (entity) {
        return this.hasVolume(entity) && entity.volumes[0].wgtNetKgs && this.numberFormat(entity.volumes[0].wgtNetKgs)
      },
      netCbFt (entity) {
        return this.hasVolume(entity) && entity.volumes[0].volNetCuf && this.numberFormat(entity.volumes[0].volNetCuf)
      },
      volNetM3 (entity) {
        return this.hasVolume(entity) && entity.volumes[0].volNetM3 && this.numberFormat(entity.volumes[0].volNetM3)
      },
      symbol (entity) {
        return this.profitLoss(entity) > 0 ? '' : '-'
      },
      profitLoss (entity) {
        return parseFloat(this.totalCharge(entity) - this.totalCost(entity)).toFixed(2)
      },
      // UI methods
      compare ({ id }) {
        this.load(id)
          .then(data => { this.comparison = data })
          .catch(console.err)
      },
      getAccessorialBaseAmount (item) {
        if (item && item.baseAmount && item.baseCurrency) {
          return `${this.numberFormat(parseFloat(item.baseAmount))} ${item.baseCurrency.code}`
        } else {
          return '0'
        }
      },
      getAccessorialDescription (item) {
        if (item && item.accessorial.description) {
          const note = item.accessorial.note ? ` (${item.accessorial.note})` : ''
          return item.accessorial.description + note
        } else {
          return ''
        }
      },
      getAccessorialAmount (item) {
        if (item && item.amount && item.currency) {
          return `${this.numberFormat(parseFloat(item.amount))} ${item.currency.code}`
        } else {
          return '0'
        }
      },
      getAccessorialSubtotal (item) {
        if (item && item.subtotal && item.currency) {
          return `${parseFloat(item.subtotal).toFixed(2)} ${item.currency.code}`
        } else {
          return '0'
        }
      },
      getAccessorialBaseSubtotal (item) {
        if (item && item.baseSubtotal && item.baseCurrency) {
          return `${parseFloat(item.baseSubtotal).toFixed(2)} ${item.baseCurrency.code}`
        } else {
          return '0'
        }
      },
      getQuoteTaxDescription (item) {
        if (item && item.serviceName) {
          const note = item.quoteTax && item.quoteTax.note ? ` (${item.quoteTax.note})` : ''
          return `${item.serviceName} ${note}`
        } else {
          return ''
        }
      },
      getChargeAmount (item) {
        if (item.amount && item.currency) {
          return `${parseFloat(item.amount).toFixed(2)} ${item.currency.code}`
        } else {
          return 'Missing data'
        }
      },
      getAmount (item) {
        if (item.amount) {
          return `${parseFloat(item.amount).toFixed(2)} ${this.quoteCurrency(this.entity)}`
        } else {
          return 'Missing data'
        }
      },
      orderBySequence (a, b) {
        return a.jobService.sequence - b.jobService.sequence
      },
      getBaseData () {
        return {}
      },
      load (id) {
        this.loading = true
        return new Promise((resolve, reject) => {
          this.$http.get(`${api.JOB}/${id}`)
            .then(({data}) => resolve(data))
            .catch(reject)
            .then(() => { this.loading = false })
        })
      },
      init () {
        this.comparison = {
          services: [],
          finances: [],
          job: {
            quoteCurrency: { code: null },
            jobType: { name: null },
            jobName: null,
            masterJob: null,
            id: null
          },
          volumes: []
        }
        this.load(this.id)
          .then(data => { this.entity = data })
          .catch(console.err)
      }
    },
    watch: {
      id () {
        this.init()
      }
    },
    mounted () {
      this.init()
    }
  }
</script>
<style scoped>
  .tag {
    text-align: center;
    margin: 5px;
  }
  .tag .key-head {
    background-color: #0095da;;
    color: #fff;
  }
  .tag .val {
    border: 1px solid #949292;
    min-height: 20px;
  }
  .comparison {
    background: #cacaca;
  }
  .btn-print {
    width: 150px;
  }
</style>



// WEBPACK FOOTER //
// Job.vue?0956c47b